import {Component, Input, OnInit} from '@angular/core';
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import { NpsHelpModalComponent } from "../nps-help-modal/nps-help-modal.component";
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-nps-help',
  templateUrl: './nps-help.component.pug',
  styleUrls: ['./nps-help.component.scss'],
  standalone: false
})
export class NpsHelpComponent implements OnInit {

  bsModalRef!: BsModalRef;
  @Input() request
  constructor(private modalService: BsModalService, private permission: PermissionsService) { }

  ngOnInit(): void {}

  showHelp(): void {
    let initialState = { 'request': this.request };
    if(this.request=='exit'){
    this.bsModalRef = this.modalService.show(NpsHelpModalComponent, {
      class: 'modal-dialog-centered modal-lg' ,initialState
    });
  }
    else if (this.request == 'pulse') {
      this.bsModalRef = this.modalService.show(NpsHelpModalComponent, {
        class: 'modal-centered max-height-468', initialState
      });
    }
  }
}
